import React from 'react';
import { useSelector } from 'react-redux';
import { useIsMobile } from './useIsMobile';
import { pickShell } from './pickShell';
import { isInternalUser } from './userKind';

interface ResponsiveShellProps {
  history: { push: (path: string) => void; location: { pathname: string } };
  onLogout: () => void;
  children: React.ReactNode;
}

/**
 * Picks the chrome by viewport (mobile < 768px) and user-kind.
 *
 * Viewport is synchronous and user-agnostic, so the frame is always correct from
 * the first paint. User-kind comes from `/me` (the cross-client source of truth,
 * read off the `me` store slice) — never the legacy `loggedUser` global, which
 * isn't populated in a CloudFront-served SPA. Default-deny: until `/me` confirms
 * the user is internal we render the client shell, which is crash-safe (the staff
 * shell pulls in staff-only modals that assume a populated `user_role`). Staff
 * briefly see the client frame on a cold load, then it swaps to the staff shell
 * once `/me` resolves.
 */
export const ResponsiveShell = (props: ResponsiveShellProps) => {
  const isMobile = useIsMobile();
  const isInternal = useSelector((s: any) => isInternalUser(s.me));
  const Shell = pickShell(!isInternal, isMobile);
  return <Shell {...props} />;
};
